import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import StoreExpenseForm from "./StoreExpenseForm";
import StoreExpense, { newStoreExpense } from "../../models/store-expense";

interface StoreExpenseUpdateModalProps {
  show: boolean;
  storeExpense?: StoreExpense;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const StoreExpenseUpdateModal: React.FC<StoreExpenseUpdateModalProps> = ({
  show,
  storeExpense,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialStoreExpense, setInitialStoreExpense] = useState<StoreExpense>(
    storeExpense ? storeExpense : newStoreExpense()
  );

  const modalTitle = storeExpense
    ? `Revertir Gasto en Sucursal: ${storeExpense.description}`
    : `Crear Gasto en Sucursal nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialStoreExpense(newStoreExpense());
    onCancel();
  };
  useEffect(() => {
    setInitialStoreExpense(storeExpense ? storeExpense : newStoreExpense());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeExpense]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <StoreExpenseForm
            initialStoreExpense={initialStoreExpense}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default StoreExpenseUpdateModal;
